const rp = require('./retry-request');

function get(url, options = {}, api_key) {
  return makeRequestWithMethod(url, parseOptions(options), api_key, 'GET')
}

function post(url, options = {}, api_key) {
  return makeRequestWithMethod(url, parseOptions(options), api_key, 'POST', options.body)
}

function put(url, options = {}, api_key) {
  return makeRequestWithMethod(url, parseOptions(options), api_key, 'PUT', options.body)
}

// Helpers
function parseOptions({headers, country_code, device_type, premium, render, session_number, autoparse, retry, timeout} = {}) {
  return {
    headers,
    country_code: country_code && String(country_code),
    device_type: device_type && String(device_type),
    premium: premium && Boolean(premium),
    render: render && Boolean(render),
    session_number: session_number && Number(session_number),
    autoparse: autoparse && Boolean(autoparse),
    retry,
    timeout
  }
}

function makeRequestWithMethod(url, options = {}, api_key, method, body) {
  return rp( {
    uri: 'https://api.scraperapi.com/',
    method,
    body,
    retry: options.retry,
    timeout: options.timeout,
    qs: {
      url: url,
      api_key: api_key,
      keep_headers: Object.entries(options.headers || {}).length > 0 ? true : undefined,
      country_code: options.country_code,
      device_type: options.device_type,
      premium: options.premium,
      render: options.render,
      session_number: options.session_number,
      autoparse: options.autoparse,
      scraper_sdk: 'node'
    },
    headers: options.headers,
  });
}

module.exports = {
  get,
  post,
  put
}
